<mat-card style="padding: 0.5in;">
  <!-- <mat-card-header> -->

  <div class="row" style="margin-bottom: 20px;">
    <div class="col-sm-6" style="text-align: left;">
      <button mat-raised-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
        Close
      </button>
    </div>
    <div class="col-sm-6" style="text-align: right;">
      <button mat-raised-button color="primary" (click)="printReport()">
        <mat-icon>print</mat-icon>
        Print Report
      </button>
    </div>
  </div>
  <!-- </mat-card-header> -->

  <mat-card-content>

    <kendo-pdf-export #pdf paperSize="letter" [scale]="0.6" [margin]="{ top: '0.75in', right: '0.25in', bottom: '0.5in', left: '0.25in' }" [repeatHeaders]="true">
      <!-- Combined header and footer template -->
      <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
        <!-- Page header with table headers (for pages 2+) -->
 
        
        <!-- Page footer -->
        <div style="position: absolute; bottom: 10px; left: 0; right: 0; text-align: center; font-size: 10pt;">
          Printed {{datePrinted}} - Page {{pageNum}} of {{totalPages}}
        </div>
      </ng-template>

      <div>
        <div class="row">
          <div class="col-sm-8">
            <span style="font-size: large"><strong>ORELAP Laboratory Technology Method List</strong></span>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-8">
                <span class="pull-right" style="font-size: large">ORELAP ID</span>
              </div>
              <div class="col-sm-4">
                <span class="pull-left" style="font-size: large">{{techData.orelapId}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">          
          <div class="col-sm-8">
            <span style="font-size: 15pt"> </span>
          </div>
          <div class="col-sm-offset-8 col-sm-4">
            <div class="row">
              <div class="col-sm-8">
                <span class="pull-right" style="font-size: large">EPA CODE</span>
              </div>
              <div class="col-sm-4">
                <span class="pull-left" style="font-size: large">{{techData.epaId}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-8">
            <span style="font-size: 15pt"> </span>
          </div>
          <div class="col-sm-offset-8 col-sm-4">
            <div class="row">
              <div class="col-sm-8">
                <span class="pull-right" style="font-size: large">Lab ID</span>
              </div>
              <div class="col-sm-4">
                <span class="pull-left" style="font-size: large">{{techData.labId}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-8">
            <span style="font-size: large"><strong>{{techData.labName}}</strong></span>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <div class="col-sm-8">
                <span class="pull-right" style="font-size: large">App ID</span>
              </div>
              <div class="col-sm-4">
                <span class="pull-left" style="font-size: large">{{techData.appId}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 10pt">
          <div class="col-sm-12">
            <table class="table table-condensed">
              <colgroup>
                <col style="width: 8%" />
                <col style="width: 14%" />
                <col style="width: 10%" />
                <col style="width: 10%" />
                <col style="width: 6%" />
                <col style="width: 6%" />
                <col style="width: 6%" />
                <col style="width: 6%" />
                <col style="width: 6%" />
                <col style="width: 28%" />
              </colgroup>
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th>Reference</th>
                  <th>Revision</th>
                  <th>Air</th>
                  <th>Bio</th>
                  <th>DW</th>
                  <th>NP</th>
                  <th>Solids</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let nameGroup of groupedTechnologies">
                  <!-- Name row -->
                  <tr>
                    <td style="background-color:#f5f5f5; border-bottom: none; font-size:larger" colspan="10">
                      <strong>{{nameGroup.name}}</strong>
                    </td>
                    <!-- <td colspan="9" style="background-color:#f5f5f5; border-bottom: solid"></td> -->
                  </tr>

                  <ng-container *ngFor="let instrumentGroup of nameGroup.instruments">
                    <!-- Instrument Technology row -->
                    <tr>
                      <td style="background-color:#f5f5f5; border-top: none"></td>
                      <td style="border-top: solid">{{instrumentGroup.instrumentTechnology}}</td>
                      <td style="border-top: solid" colspan="8"></td>
                    </tr>

                    <!-- Technology detail rows -->
                    <tr *ngFor="let tech of instrumentGroup.technologies">
                      <td style="background-color:#f5f5f5; border-top: none"></td>
                      <td style="border-top:none"></td>
                      <td style="border-top:none">{{tech.reference}}</td>
                      <td style="border-top:none">{{tech.revision}}</td>
                      <td style="border-top:none; text-align: center;">{{tech.air}}</td>
                      <td style="border-top:none; text-align: center;">{{tech.biological}}</td>
                      <td style="border-top:none; text-align: center;">{{tech.drinkingWater}}</td>
                      <td style="border-top:none; text-align: center;">{{tech.nonPotable}}</td>
                      <td style="border-top:none; text-align: center;">{{tech.solids}}</td>
                      <td style="border-top:none">{{tech.title}}</td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </kendo-pdf-export>
  </mat-card-content>
</mat-card>